import axios from 'axios';

class BackendService {
  constructor() {
    this.baseURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
  }

  async searchDatabase(query) {
    try {
      const response = await axios.post(`${this.baseURL}/api/search`, { query });
      return response.data;
    } catch (error) {
      console.error('Error searching database:', error);
      return null;
    }
  }

  async saveToDatabase(content, fileName) {
    try {
      const response = await axios.post(`${this.baseURL}/api/save`, { content, fileName });
      return response.data;
    } catch (error) {
      console.error('Error saving to database:', error);
      return null;
    }
  }

  async getFileContent(fileId) {
    try {
      const response = await axios.get(`${this.baseURL}/api/file/${fileId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting file content:', error);
      return null;
    }
  }
}

export default BackendService;
